import { DRIVE_API_V1 } from '@/api'
import localforage from 'localforage'
import _ from 'lodash'
import { useUserInfo } from '~/store/userInfo'

export enum ResourceStatus {
  'UNKNOWN',
  'OK',
  'LIMITED',
}

const iconUrls: Record<string, string> = {
  video: 'https://static.mypikpak.com/39998a187e280e2ee9ceb5f58315a1bcc744fa64',
  text: 'https://static.mypikpak.com/0d8b20b308a8f2fb094caba73cd2b809f7f3c636',
  image: 'https://static.mypikpak.com/b418dc7eaf8f269e5a9e196262039b2abb042f6e',
  audio: 'https://static.mypikpak.com/e23dac600c0e80efb9238ed239f9ca765ad9f313',
  archive: 'https://static.mypikpak.com/b3b126bdf947390223e9ffd88a3e61a40ade228f',
  folder: 'https://static.mypikpak.com/7d6933d5cde34f200366685cba0cbc4592cfd363',
  unknown: 'https://static.mypikpak.com/0ed033dfc7b3862af92a52ef7e3e4d257223df81',
}

export const resolveWhatsLink = (url: string): Promise<WhatslinkResurce> => fetch(
  `https://whatslink.info/api/v1/link?url=${encodeURIComponent(url)}`,
  { method: 'GET' },
).then(response => response.json()).catch(() => ({}))

export const checkResolveStatus = (url: string): Promise<{
  status: 'UNKNOWN' | 'OK' | 'LIMITED' | 'ERROR'
}> => fetch(
  `${DRIVE_API_V1}/resource/status?url=${encodeURIComponent(url)}`,
  {
    method: 'GET',
    headers: { 'X-Request-From': window.location.origin + window.location.pathname },
  },
).then(response => response.json()).catch(() => ({ status: 'ERROR' }))

export async function resolveResource(url: string): Promise<{
  data: { value: Resource }
  error: { value?: any }
}> {
  try {
    const [linkInfo, linkStatus] = await Promise.all([
      resolveWhatsLink(url),
      checkResolveStatus(url),
    ])
    if (linkStatus.status === 'LIMITED' || linkStatus.status === 'ERROR') {
      return {
        data: { value: null as any },
        error: {
          value: { error: linkStatus.status === 'LIMITED' ? 'extremist_content' : 'error_content' },
        },
      }
    }
    // 数据转换 WhatslinkResurce => Resource
    return {
      data: {
        value: {
          list: {
            resources: [
              {
                file_count: linkInfo.count,
                file_size: `${linkInfo.size}`,
                is_dir: linkInfo.type === 'FOLDER',
                file_index: 0,
                meta: {
                  icon: iconUrls[linkInfo.file_type || 'unknown'] || iconUrls.unknown,
                  thumbnail_link: linkInfo.screenshots?.[0]?.screenshot,
                  status: linkStatus.status === 'OK' ? '1' : undefined,
                },
                name: linkInfo.name,
              },
            ],
          },
        } as any,
      },
      error: { value: null },
    }
  } catch (err) {
    console.error('[resolveResource failure]: ', err)
    return {
      data: { value: null as any },
      error: {
        value: {
          error: 'unknown_content',
        },
      },
    }
  }
}

// region 避免用户重复举报链接
export class UniqueResourceReport {
  private static userId(): string | undefined {
    return useUserInfo().userId
  }

  private static getStorage(): LocalForage | undefined {
    try {
      return localforage.createInstance({ name: 'pikpak', storeName: 'report_url' })
    } catch (e) {
      console.error(e)
    }
  }

  static async get(): Promise<string[] | null> {
    try {
      const userId = this.userId()
      if (!userId) return null
      return await this.getStorage()?.getItem<string[]>(userId) || null
    } catch (e) {
      console.error(e)
      return null
    }
  }

  static set(url: string): void {
    try {
      const userId = this.userId()
      if (!userId) return
      const oldValue = this.get()
      if (_.isArray(oldValue)) {
        this.getStorage()?.setItem(userId, _(oldValue).concat(url).uniq().value())
      } else {
        this.getStorage()?.setItem(userId, [url])
      }
    } catch (e) {
      console.error(e)
    }
  }

  static async exist(url: string): Promise<boolean> {
    return !!(await this.get())?.includes(url)
  }
}

// endregion
